import { databaseRef } from 'config/firebase'

export const getIsPlusUser = async (userId: string) => {
  const plusUser = (
    await databaseRef
      .child('plus_users')
      .child(userId)
      .once('value')
  ).val()

  return !!plusUser?.is_plus ? true : false
}

export const setPlusUser = async (
  userId: string,
  plusUserLib: any,
  isFromPaymentPage: boolean
) => {
  const isPlusUser = isFromPaymentPage ? true : await getIsPlusUser(userId)
  plusUserLib.add(isPlusUser)
}

export const clearPlusUser = async (plusUserLib: any) => {
  plusUserLib.clear()
}

export const updatePlusUser = async (userId: string, plusUserLib: any) => {
  plusUserLib.clearLoaded()
  const isPlusUser = await getIsPlusUser(userId)
  plusUserLib.add(isPlusUser)
}

export const listenPlusUser = (
  userId: string,
  onChange: (child: any) => void = () => {
    return
  },
  onError: (message: string) => void = () => {
    return
  }
): any => {
  try {
    const ref = databaseRef.child('plus_users').child(userId)
    const f = ref.on(
      'value',
      snapshot =>
        snapshot &&
        onChange((snapshot.val() && snapshot.val().is_plus) || false)
    )

    return () => ref.off('value', f)
  } catch (e) {
    if (e?.message) {
      onError(e.message)
    }

    return () => {
      return
    }
  }
}

export default {
  setPlusUser,
  getIsPlusUser,
  listenPlusUser,
  updatePlusUser
}



// WEBPACK FOOTER //
// ./src/services/plusUsers.ts